"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _services = require("../services");
var _constants = require("../utils/constants");
var _uiSelectors = require("../store/ui/uiSelectors");
var _useLocalTheme = _interopRequireDefault(require("../hooks/useLocalTheme"));
var _useAppSelector = require("../hooks/useAppSelector");
var _useQuestionnaireNavigation = require("../hooks/questionnaire/useQuestionnaireNavigation");
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StepperContainer = _styledComponents.default.div`
  ${props => props.showBroadbandModal && (0, _styledComponents.css)`
      & [class^='Stepstyle__Step'] {
        padding: 0 !important;
      }
      & [class^='Stepstyle__StepTitle'] {
        padding-top: 5px !important;
        line-height: ${props.stepLineHeightStyle}px;
      }
    `}
`;
const getStep = (page, steps, currentIndex) => {
  switch (page) {
    case _constants.PAGES.RECOMMENDATION:
      return steps.length;
    case _constants.PAGES.SUMMARY:
      return steps.length - 1;
    default:
      return currentIndex + 1;
  }
};
const STEPS = [_constants.PAGES.QUESTIONNAIRE, _constants.PAGES.RECOMMENDATION];
const Stepper = () => {
  const showBroadbandModal = (0, _useConfig.default)('uiSettings.showBroadbandModal', false);
  const removeHorizontalStepperTitles = (0, _useConfig.default)('uiSettings.removeHorizontalStepperTitles', false);
  const recommendationStep = _services.locale.localeString('Recommendation.RecommendationStep');
  const shortRecommendationStep = _services.locale.localeString('Recommendation.ShortRecommendationStep');
  const {
    currentQuestionIndex,
    journeySteps
  } = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)();
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const recommendationSteps = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectSteps) || [];
  const showMainStepper = (0, _useLocalTheme.default)('showMainStepper', false);
  const stepLineHeightStyle = (0, _useLocalTheme.default)('stepLineHeightStyle', 20);
  const [currentStep, setStep] = (0, _react.useState)(1);
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const broadbandModalSteps = (0, _react.useMemo)(() => {
    const steps = recommendationSteps.length > 0 ? [...recommendationSteps, {
      title: breakpoints.sm ? shortRecommendationStep : recommendationStep
    }] : [...journeySteps, {
      title: breakpoints.sm ? shortRecommendationStep : recommendationStep
    }];
    return removeHorizontalStepperTitles ? steps.map((s, i) => i + 1 !== currentStep ? {
      title: ''
    } : s) : steps;
  }, [recommendationSteps, journeySteps, currentStep]);
  const currentIndex = (0, _react.useMemo)(() => currentQuestionIndex > -1 ? currentQuestionIndex : (journeySteps === null || journeySteps === void 0 ? void 0 : journeySteps.length) - 1, [currentQuestionIndex, journeySteps]);
  if (!showMainStepper) return null;
  const steps = (0, _react.useMemo)(() => showBroadbandModal ? broadbandModalSteps : defaultSteps, [showBroadbandModal, broadbandModalSteps]);
  const defaultSteps = STEPS.map(s => ({
    title: _services.locale.localeString(`MainStepper.${s.toLowerCase()}`)
  }));
  (0, _react.useEffect)(() => {
    const pageStep = STEPS.findIndex(s => s === currentPage);
    setStep(showBroadbandModal ? getStep(currentPage, steps, currentIndex) : pageStep + 1);
  }, [currentPage, currentIndex]);
  if (currentStep === 0) return null;
  return /*#__PURE__*/_react.default.createElement(StepperContainer, {
    id: "horizontal-stepper",
    showBroadbandModal: true,
    stepLineHeightStyle: stepLineHeightStyle
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.HorizontalStepper, {
    currentStep: currentStep,
    steps: steps,
    id: "main-stepper",
    inverse: showBroadbandModal
  }));
};
var _default = Stepper;
exports.default = _default;